import LoaderSpin from 'snippets/loader-spin/loader-spin'

function ButtonATC({ text, onHandle, loading, disabled = false, buttonClass = '' }) {
  const classCustom = `relative w-full button-primary ${!disabled ? '' : 'text-grey-400'} button-large`
  return (
    <button aria-label="add to cart" title={text} type="button" className={buttonClass || classCustom} disabled={disabled} onClick={() => onHandle()}>
      {loading ? (
        <LoaderSpin />
      ) : (
        <>
          {text}
        </>
      )}
    </button>
  )
}

export default ButtonATC
